module.exports = __webpack_public_path__ + "static/img/12.2414e57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/12.png
// module id = 9PQ2
// module chunks = 1